import firestore from "../../../firebase/firestore";

export default {
  resetState({ commit }) {
    commit("resetState");
  },

  async getQualifications({ state, commit }, params) {
    try {
      await commit("setLoading", true);
      const cpf = params?.cpf;
      const qualification_ids = params?.qualification_ids || [];

      return firestore
        .collection("qualification")
        .where("cpf", "==", cpf)
        .onSnapshot(async (res) => {
          if (res.size > 0) {
            const changes = res.docChanges();
            changes.forEach(async (change) => {
              const { doc } = change;
              switch (change.type) {
                case "added": {
                  let new_doc = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  if (!qualification_ids?.includes(new_doc.id)) break;
                  if (new_doc.consumer_unit) {
                    let consumer_unit = await firestore
                      .collection("qualification")
                      .doc(new_doc.id)
                      .collection("consumer_units")
                      .doc(new_doc.consumer_unit)
                      .get();
                    if (consumer_unit)
                      new_doc.consumer_unit_detail = {
                        id: consumer_unit.id,
                        ...consumer_unit.data(),
                      };
                  }
                  if (
                    !state.qualifications.some(
                      (item) => item.consumer_unit == new_doc.consumer_unit,
                    )
                  ) {
                    await commit("pushQualification", new_doc);
                  }
                  break;
                }
                case "modified": {
                  let new_doc = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  if (!qualification_ids.includes(new_doc.id)) break;
                  if (new_doc.consumer_unit) {
                    let consumer_unit = await firestore
                      .collection("qualification")
                      .doc(new_doc.id)
                      .collection("consumer_units")
                      .doc(new_doc.consumer_unit)
                      .get();
                    if (consumer_unit)
                      new_doc.consumer_unit_detail = {
                        id: consumer_unit.id,
                        ...consumer_unit.data(),
                      };
                  }
                  const index = state.qualifications.findIndex(
                    (i) => i.id === doc.id,
                  );
                  await commit("spliceQualifications", {
                    index,
                    data: new_doc,
                  });
                  break;
                }
                case "removed": {
                  state.qualifications.filter((i) => i.id !== doc.id);
                  break;
                }
                default:
                  break;
              }
            });
            commit("setLoading", false);
            return true;
          } else {
            await commit("setQualifications", []);
          }
          await commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setQualifications", []);
      console.error(err);
    }
  },

  async getQualificationsUnresolved({ commit }) {
    commit("setLoading", true);
    let qualificationsList = [];
    return (
      firestore
        .collection("qualification")
        .where("status", "in", ["error", "bill_not_found", "pending"])
        .where("created_at", ">", new Date("2021-06-09"))
        .orderBy("created_at", "desc")
        // .limit(15)
        .onSnapshot(async (res) => {
          const changes = res.docChanges();
          // console.log('changes', changes)
          // console.log('qualificationsList', qualificationsList)
          // eslint-disable-next-line no-unused-vars
          for (const [index, change] of changes.entries()) {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                // if (new_doc.consumer_unit) {
                //     let uc = await firestore.collection('consumer_units')
                //         .doc(new_doc.consumer_unit).get();
                //     if (uc.exists) new_doc.consumer_unit_exists = true;
                //     else new_doc.consumer_unit_exists = false;
                // }
                if (new_doc.cpf) {
                  let query = await firestore
                    .collection("users")
                    .where("cpf", "==", new_doc.cpf)
                    .limit(1)
                    .get();
                  // console.log('got user', index)
                  if (query && query.docs && query.docs[0]) {
                    new_doc.user_detail = {
                      id: query.docs[0].id,
                      ...query.docs[0].data(),
                    };
                    if (
                      new_doc.user_detail.signedcontract_by &&
                      new_doc.user_detail.status !=
                        "AGUARDANDO_NRO_INSTALACAO" &&
                      new_doc.user_detail.status != "DESQUALIFICAR" &&
                      new_doc.user_detail.status != "AGUARDANDO_CONTA"
                    ) {
                      qualificationsList.push(new_doc);
                    }
                  }
                }
                break;
              }
              case "modified": {
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                };
                // if (new_doc.consumer_unit) {
                //     let uc = await firestore.collection('consumer_units')
                //         .doc(new_doc.consumer_unit).get();
                //     if (uc.exists) break;
                // }
                if (new_doc.cpf) {
                  let query = await firestore
                    .collection("users")
                    .where("cpf", "==", new_doc.cpf)
                    .limit(1)
                    .get();
                  if (query && query.docs && query.docs[0]) {
                    new_doc.user_detail = {
                      id: query.docs[0].id,
                      ...query.docs[0].data(),
                    };
                    const i = qualificationsList.findIndex(
                      (i) => i.id === doc.id,
                    );
                    if (
                      new_doc.user_detail.signedcontract_by &&
                      new_doc.user_detail.status !=
                        "AGUARDANDO_NRO_INSTALACAO" &&
                      new_doc.user_detail.status != "DESQUALIFICAR" &&
                      new_doc.user_detail.status != "AGUARDANDO_CONTA"
                    ) {
                      qualificationsList.splice(i, 1, new_doc);
                    }
                  }
                }
                break;
              }
              case "removed": {
                qualificationsList = qualificationsList.filter(
                  (i) => i.id !== doc.id,
                );
                break;
              }
              default:
                break;
            }
          }
          commit("setLoading", false);
          await commit("setQualificationsUnresolved", qualificationsList);
          return qualificationsList;
        })
    );
  },

  async getAllLeadQualifications({ state, commit }, cpf) {
    await commit("setQualifications", []);
    try {
      await commit("setLoading", true);

      return firestore
        .collection("qualification")
        .where("cpf", "==", cpf)
        .onSnapshot(async (res) => {
          if (res.size > 0) {
            const changes = res.docChanges();
            changes.forEach(async (change) => {
              const { doc } = change;
              switch (change.type) {
                case "added": {
                  const new_doc = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  if (new_doc.consumer_unit) {
                    let consumer_unit = await firestore
                      .collection("qualification")
                      .doc(new_doc.id)
                      .collection("consumer_units")
                      .doc(new_doc.consumer_unit)
                      .get();
                    if (consumer_unit)
                      new_doc.consumer_unit_detail = {
                        id: consumer_unit.id,
                        ...consumer_unit.data(),
                      };
                  }
                  await commit("pushQualification", new_doc);
                  break;
                }
                case "modified": {
                  const new_doc = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  if (new_doc.consumer_unit) {
                    let consumer_unit = await firestore
                      .collection("qualification")
                      .doc(new_doc.id)
                      .collection("consumer_units")
                      .doc(new_doc.consumer_unit)
                      .get();
                    if (consumer_unit)
                      new_doc.consumer_unit_detail = {
                        id: consumer_unit.id,
                        ...consumer_unit.data(),
                      };
                  }
                  const index = state.qualifications.findIndex(
                    (i) => i.id === doc.id,
                  );
                  await commit("spliceQualifications", {
                    index,
                    data: new_doc,
                  });
                  break;
                }
                case "removed": {
                  const newQualifications = state.qualifications.filter(
                    (i) => i.id !== doc.id,
                  );
                  await commit("setQualifications", newQualifications);
                  break;
                }
                default:
                  break;
              }
            });
            commit("setLoading", false);
            return true;
          } else {
            await commit("setQualifications", []);
          }
          await commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setQualifications", []);
      console.error(err);
    }
  },

  pushQualificationsForm({ commit }, qualifications) {
    for (const qualification of qualifications) {
      commit("pushQualification", qualification);
    }
  },
};
